import * as api from '@/services/schedule';

export default {
  namespace: 'schedule',
  state: {
  },
  effects: {
    *getAppointDayTeacherSchedule({ payload }: any, { call }: any): any {
      const res = yield call(api.getAppointDayTeacherSchedule, payload);
      return res
    },

    *updateOpenBookDemo({ payload }: any, { call }: any): any {
      return yield call(api.updateOpenBookDemo, payload);
    },
  },
  reducers: {
    _setState(state: any, { payload }: any) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};